import {BehaviorSubject} from "rxjs";

export interface ICustomerType {
    id: number,
    id_ui: string,
    name: string,

    bAddressShowInd: boolean
    bAddressSearchByInd: boolean
    bSalesAreaShowInd: boolean
    bSalesAreaSearchByInd: boolean
    bStatusShowInd: boolean
    bStatusSearchByInd: boolean
    CustomerFieldsShowInd: {
        [id:string]: boolean
    },
    SalesAreaFieldsShowInd: {
        [id:string]: boolean
    },

}

// These fields should align with the domain, Customer_Header_Attributes
export const CustomerHeaderFields = [
    // backward compatible
    'CONSUMPTION_IND',
    'SHIPMENT_IND',
    'PLANNING_CUSTOMER_IND',
    'TERRITORY_IND',
    'COMPANY_CODE',
    'TREE_PATH',

    'CUSTOMER_NAME_2',
    'REGIONAL_MARKET',
    'CUSTOMER_CLASSIFICATION',
    'ACCOUNT_GROUP',
    'INDUSTRY_CODE1',
    'INDUSTRY_CODE2',
    'INDUSTRY_CODE3',
    'VAT_LIABLE_IND',
    'PAYMENT_BLOCK_IND',
    'ORDER_BLOCK_IND',
    'BILLING_BLOCK_IND',
    'EXT_DELETION_IND',
]

export interface IHaveCustomerType {
    CustomerType: ICustomerType,
    CustomerTypesAll: ICustomerType[],
    setCustomerType(cr: ICustomerType): void
    CustomerTypeChanged: BehaviorSubject<IHaveCustomerType>
}
